<template>
  <div :class="[product.product_images.length > 1 ? 'pdp-image-container m-auto' : 'pdp-image-container m-auto']">
    <BCarousel v-if="sliderControlsEnabled" :images="images" />
    <img v-else :src="determineImageToShow(product)" :alt="product.name" class="featured-product-image" />
  </div>
</template>
<script>
import BCarousel from "@/components/base/BCarousel.vue";

export default {
  name: "ProductDisplayPageImages",
  components: {
    BCarousel,
  },
  props: {
    product: { type: Object, required: true },
  },
  data() {
    return {
      images: [],
      slide: 0,
      sliding: null,
      sliderSpeed: 10000,
      sliderControlsEnabled: false,
      sliderIndecatorsEnabled: true,
      sliderFadeEnabled: false,
      sliderAnimationDisabled: false,
      sliderPauseOnHover: true,
    };
  },
  mounted() {
    if (this.product.product_images && this.product.product_images.length > 1) {
      this.sliderControlsEnabled = true;
      this.images = this.getImages();
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    determineImageToShow(product) {
      if (product.product_images && product.product_images.length > 0) {
        return product.product_images[0].imageLink;
      }
      if (product.brand && product.brand.logoLink && !product.brand.logoLink.includes("gravatar") && !product.brand.logoLink.includes("no-image")) {
        return product.brand.logoLink;
      }

      if (this.product.company.logoLink && !this.product.company.logoLink.includes("gravatar")) {
        return this.product.company.logoLink;
      }

      return "/img/misc/no-image-square.png";
    },
    getImages() {
      const images = [];
      if (this.product.product_images && this.product.product_images.length > 0) {
        this.product.product_images.forEach((image) => {
          images.push(image.imageLink);
        });
      }

      return images;
    },
    log(e) {
      console.log(e);
    },
  },
};
</script>
<style>
.p-galleria-nav-button {
  color: #000 !important;
}
</style>

<style scoped lang="scss">
@import "@sass/_variables.scss";
@import "@sass/_mixins.scss";
.pdp-image-container {
  // width: 100%;//calc(100% + 4.75em);
  // height: 100%;
  // max-height: 400px;
  // width: 400px;
  width: 100%;
  height: 320px;
  max-width: 320px;
  // margin: -1em -2.5em 0.5em;
  overflow: hidden;
  img {
    // object-fit: cover;
    // object-fit: contain;
    // vertical-align: middle;
    // width: 100%;
    // height: 100%;
    // min-height: 300px;
    // max-height: 400px;
    width: 100%;
    max-width: 320px;
    object-fit: cover;
    height: 320px;
    // width: 400px;
  }
}
// .pdp-image-container-with-carousel {
//     // width: 100%; //calc(100% + 4.75em);
//     // height: 100%;
//   //  max-height: 400px;
//     width: 500px;
//     height: 500px;
//     margin: -1em -2.5em 0.5em;
//     overflow: hidden;
//     &.with-carousel {
//         //
//     }
//     img {
//     //     // object-fit: cover;
//     //     object-fit: contain;
//     //     vertical-align: middle;
//     //     width: 100%;
//     //     height: 100%;
//     //     min-height: 300px;
//     //     max-height: 400px;
//     object-fit: contain;
//     height: 500px;
//     width: 500px;
//     }
// }
</style>
